/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Video from '../partials/Video';

import styles from '../../styles/blocks/video-block.module.css';

const propTypes = {
    media: AppPropTypes.video.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function VideoBlock({ media, className }) {
    const { width, height } = media || {};
    const vertical = height > width;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.vertical]: vertical,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([styles.shape, 'contain-size'])}
                style={{
                    paddingBottom: `${(height / width) * 100}%`,
                }}
            >
                {media !== null ? (
                    <Video media={media} nativeControls className={styles.video} withoutBlock />
                ) : null}
            </div>
        </div>
    );
}

VideoBlock.propTypes = propTypes;
VideoBlock.defaultProps = defaultProps;

export default VideoBlock;
